import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { isAuthDisabled, isAuthLoading, isNotAuthenticated } from '../../utils/authStateHelpers';
import api from '../../services';
import ZuulLoader from '../ZuulLoader/ZuulLoader';

const ProtectedRoute = ({ children }) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (isAuthLoading(authState)) {
    // ZuulLoader centres itself; the Row/Col this used to sit in only added Bootstrap gutters.
    return <ZuulLoader text={'Checking authentication state...'} />;
  }

  if (isNotAuthenticated(authState)) {
    sessionStorage.setItem('preLoginUrl', location.pathname + location.search);
    return <Navigate to='/login' replace />;
  }

  if (!isAuthDisabled() && authState.accessToken?.accessToken) {
    // Set API authorization header using authState
    api.defaults.headers.common.Authorization = `Bearer ${authState.accessToken.accessToken}`;
  }

  return children;
};

export default ProtectedRoute;
